import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Badge} from 'shared/models/badges/badge';
import {BadgeType} from 'shared/models/badges/badge-type';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {BadgesOverviewService} from './services/badges-overview.service';
import {BadgesDetailsService} from '../badges-details/services/badges-details.service';

@Component({
  selector: 'badges-overview',
  templateUrl: './badges-overview.component.html',
  styleUrls: ['./badges-overview.component.css'],
})
export class BadgesOverviewComponent implements OnInit {

  public badgeTypes: Array<BadgeType>;
  public badgeType: string;
  public activeStatus: 'all' | 'active' | 'inactive' = 'all';
  private badges: Array<Badge> = [];
  public filteredBadges: Array<Badge> = [];
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;

  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private badgesOverviewService: BadgesOverviewService,
    private badgesDetailsService: BadgesDetailsService,
    private router: Router) {

    this.badges = [];
    this.badgeTypes = [
      {name: 'morningImpulse', prettyName: 'Morgenimpuls', validate: () => { return 'empty'; }},
      {name: 'energyLevelMorning', prettyName: 'Energielevel morgens', validate: () => { return 'empty'; }},
      {name: 'energyLevelEvening', prettyName: 'Energielevel abends', validate: () => { return 'empty'; }},
      {name: 'performanceLevel', prettyName: 'Performancelevel', validate: () => { return 'empty'; }},
    ];
    this.badgeType = 'all';
    this.sortBadgeTypes();
  }

  public ngOnInit(): void {
    this.badgesOverviewService.getBadges()
      .subscribe((badges: Array<Badge>) => {
        this.badges = badges;
        this.filteredBadges = badges;
        this.prepareFieldsToSearch();
      });
  }

  public editBadge(id: string): void {
    this.router.navigate(['badges', 'details', {badgeId: id}]);
  }

  public createBadge(): void {
    //this.router.navigateByUrl('badges/details');
    this.router.navigate(['badges', 'details', {orderno: this.badges.length+1}]);
  }

  public deleteBadge(id: string): void {
    this.badgesOverviewService.deleteBadge(id)
      .subscribe(() => {
        const index: number = this.badges.findIndex((badge: Badge) => {
          return badge._id === id;
        });

        if (index > -1) {
          this.badges.splice(index, 1);
        }
      });
  }

  public showDeleteModal(id: string): void {
    const badgeName: string = this.getBadgeById(id).title.de;
    const content: string = `Sind Sie sicher, dass Sie den Badge "${badgeName}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public get filteredBadgesByBadgeType(): Array<Badge> {
    return this.badges.filter((badge) => {
      return this.filterByBadgeType(badge);
    });
  }

  public filteredBadgesByActiveStatus(badgesTemp: Array<Badge>): Array<Badge> {
    return badgesTemp.filter((badge) => {
      return this.filterByActiveStatus(badge);
    });
  }

  public get filteredBadgesByTypeAndStatus(): Array<Badge> {
    return this.filteredBadgesByActiveStatus(this.filteredBadgesByBadgeType);
  }

  public filterBadges(eventBadges: Array<Badge>): void {
    this.filteredBadges = eventBadges;
  }

  public prepareFieldsToSearch(): void {
    this.fieldsToSearch = [];
    this.filteredBadgesByTypeAndStatus.forEach((badge) => {
      this.fieldsToSearch.push([
        badge.description.de.toLowerCase(),
        badge.title.de.toLowerCase(),
      ]);
    });
  }

  private filterByBadgeType(badge: Badge): boolean {
    if (this.badgeType === 'all') {
      return true;
    }

    return this.badgeType === badge.type.name;
  }

  private filterByActiveStatus(badge: Badge): boolean {
    if (this.activeStatus === 'all') {
      return true;
    }

    const active: boolean = this.activeStatus === 'active';
    return badge.active === active;
  }

  private getBadgeById(id: string): Badge {
    return this.badges.find((badge: Badge) => {
      return badge._id === id;
    });
  }

  private sortBadgeTypes(): void {
    this.badgeTypes.sort((leftBadgeType: BadgeType, rightBadgeType: BadgeType) => {
      if (leftBadgeType.prettyName < rightBadgeType.prettyName) {
        return -1;
      }

      if (leftBadgeType.prettyName > rightBadgeType.prettyName) {
        return 1;
      }

      return 0;
    });
  }

  public getActiveIcon(badge: Badge): string { // tslint:disable-line
    return badge.active ? 'glyphicon-ok' : 'glyphicon-remove';
  }

  public getActiveClass(badge: Badge): string { // tslint:disable-line
    return badge.active ? 'no-button-success' : 'no-button-danger';
  }

  public isFirstBadge(badge: Badge): boolean {
    return badge.orderno == 1;
  }

  public isLastBadge(badge: Badge): boolean {
    return badge.orderno == this.badges.length;
  }

  public changeSort(badge1: Badge, dir: number) {
    const badge2 = this.badges.find((badge: Badge) => { return badge.orderno == badge1.orderno+dir; });
    badge1.orderno += dir;
    badge2.orderno -= dir;
    this.badgesDetailsService.updateBadge(badge1)
      .subscribe((badge: Badge) => {
        this.badgesDetailsService.updateBadge(badge2)
         .subscribe((badge: Badge) => {
           this.badges = this.badges.sort((b1, b2) => {
             return b1.orderno < b2.orderno ? -1 : 1;
           });
           this.badges = [...this.badges];
         });
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-overview/badges-overview.component.ts